import { Component, ElementRef, ViewChild } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

import { ApiService } from "@bitwarden/common/abstractions/api.service";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { MessagingService } from "@bitwarden/common/abstractions/messaging.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { UserVerificationService } from "@bitwarden/common/abstractions/userVerification/userVerification.service.abstraction";
import { Verification } from "@bitwarden/common/types/verification";

@Component({
  selector: "app-deauthorize-sessions",
  templateUrl: "deauthorize-sessions.component.html",
})
export class DeauthorizeSessionsComponent {
  masterPassword: Verification;
  formPromise: Promise<unknown>;

  @ViewChild("modal", { static: true }) modal: ElementRef;

  constructor(
    private apiService: ApiService,
    private i18nService: I18nService,
    private platformUtilsService: PlatformUtilsService,
    private userVerificationService: UserVerificationService,
    private messagingService: MessagingService,
    private logService: LogService,
    private dialogRef: MatDialogRef<DeauthorizeSessionsComponent>,
  ) {}

  async submit() {
    try {
      this.formPromise = this.userVerificationService
        .buildRequest(this.masterPassword)
        .then((request) => this.apiService.postSecurityStamp(request));
      await this.formPromise;
      this.platformUtilsService.showToast(
        "success",
        this.i18nService.t("sessionsDeauthorized"),
        this.i18nService.t("logBackIn"),
      );
      this.messagingService.send("logout");
      this.dialogRef.close();
    } catch (e) {
      this.logService.error(e);
    }
  }
}
